"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const common_utils_1 = require("@zapier/common-utils");
const Notification_1 = __importDefault(require("./Notification"));
const rootStyle = core_1.css `
  align-items: center;
  display: grid;
  grid-gap: 20px;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 65px;
  width: 100vw;
  z-index: 1000;
`;
function Notifications(props) {
    const notifications = props.notifications.map((notification, i) => (common_utils_1.isolateComponent(Notification_1.default, { index: i, key: notification.id, notification: notification, onDismiss: props.onDismiss, timeout: props.timeout })));
    return common_utils_1.isolateComponent("div", { css: rootStyle }, notifications);
}
exports.default = Notifications;
